export default "__VITE_ASSET__UxAIr03ohgrruZoRR5cLDg__"